<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false">

    <h1>{{ $t('skirental.pick-equipment') }}</h1>

    <div class="flex">
      <div v-for="(option, key) in params.options">
        <button class="small white underlined" @click="clicked(key)" v-if="option">{{option.name}}</button>
      </div>
    </div>

  </Modal>
</template>

<script>
import Modal from '@/components/components/Modal';
import { mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'confirmedAccomodations',
    ]),
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'addRentalPeople',
    ]),
    clicked(key) {
      this.params.click(key);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.flex
  display flex
  flex-wrap wrap
  justify-content space-between
  div
    width 50%
    text-align center
    margin-bottom 10px
    button
      width 90%
</style>



// WEBPACK FOOTER //
// SkiRentalCategories.vue?3b8b998b